import { Controller } from "@hotwired/stimulus"
import VimeoPlayer from '@vimeo/player'
import { post } from "@rails/request.js" // make sure it's installed
import { throttle } from "../../assets/src/lib/throttle";
import { getCSRFToken } from "../../assets/src/lib/csrf";

const ThrottleDelay = 5000

export default class extends Controller {
  static targets = [ "vimeo" ]
  static values = {
    completedAtPercent: Number,
    progressSeconds: Number,
    progressUrl: String,
  }

  connect() {
    // console.log("Course Stimulus", this.completedAtPercentValue, this.progressUrlValue)
  }

  vimeoTargetConnected() {
    this.vimeo = new VimeoPlayer(this.vimeoTarget)
    this.vimeo.controller = this
    this.throttledTimeUpdate = throttle(ThrottleDelay, this.timeupdate)
    this.vimeo.on('timeupdate', this.throttledTimeUpdate)
    this.vimeo.on('ended', this.timeupdate)
    // this.vimeo.getVideoTitle().then(title =>
    //   console.log("Found Vimeo video:", title)
    // )
    this.vimeo.setCurrentTime(this.progressSecondsValue)
  }

  vimeoTargetDisconnected() {
    if (this.vimeo) {
      this.vimeo.off('timeupdate', this.throttledTimeUpdate)
      this.vimeo.off('ended', this.timeupdate)
      this.throttledTimeUpdate = null
    }
  }

  timeupdate({percent}) {
    const c = this.controller
    percent = percent * 100
    // console.log("playing the video at", percent, "percent", c)
    c.updateProgress(percent)
  }

  markAsWatched(event) {
    event.preventDefault()
    this.updateProgress(100)
  }

  markAsUnwatched(event) {
    event.preventDefault()
    this.updateProgress(0)
  }

  updateProgress(percent) {
    post(this.progressUrlValue, {
      body: JSON.stringify({percent: percent}),
      headers: { 'Accept': 'text/vnd.turbo-stream.html, text/html',
                 "X-CSRF-Token": getCSRFToken()
               }
    })
      .then(r => r.text )
      .then(html => Turbo.renderStreamMessage(html))
  }
}
